export const showToast = (
  message: string,
  variant?: 'success' | 'error' | 'warning' | 'info',
) => {
  if (typeof window !== 'undefined' && (window as any).showToast) {
    (window as any).showToast(message, variant);
  } else {
    console.error('ToastManager is not initialized yet.');
  }
};
